export default __webpack_public_path__ + "static/media/kitchen5-afterD-768w.b132c2af.png";